import React, { Component } from "react";
import PropTypes from "prop-types";
import IconWithBackground from "containers/chat/IconWithBackground/IconWithBackground";
import { IoMdImage } from "react-icons/io";
import FormInputWithHeader from "components/FormInputWithHeader/FormInputWithHeader";
import Button from "Button/Button";
import "./AddBrochureForm.scss";
import FileInput from "components/FileInput/FileInput";
import { uepClient } from "uepClient";
import WithAlert from "hoc/WithAlert";

class AddBrochureForm extends Component {
  static propTypes = {
    onAddBrochureFormClose: PropTypes.func.isRequired,
    onNewBrochureAdded: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isEditMode: false,
    brochureToUpdate: null,
  };

  constructor() {
    super();
    this.state = {
      isEditMode: false,
      isFormSubmissionInProgress: false,
      brochureFile: null,
      brochureFileName: "",
      brochureId: 0,
      fileType: "BROCHURE"
    };
  }

  componentDidMount() {
    this.populateFormWithExistingBrochureDetails();
  }

  render() {
    const { isFormSubmissionInProgress } = this.state;
    const { isEditMode } = this.props;
    return (
      <div className="add-brochure-form">
        <div className="add-brochure-form-header">
          <div className="image-icon-ctr">
            <IconWithBackground
              icon={<IoMdImage color="white" className="image-icon" />}
            />
          </div>
          <div className="header-label">
            {isEditMode ? "Edit Brochure" : "Add Brochure"}
          </div>
        </div>
        <div className="form-content">
          <form className="brochure-form" onSubmit={this.onFormSubmit}>
            <div className="form-section file">
              <FormInputWithHeader
                header="File Name"
                content={this.renderFileInput()}
                isBoldHeader
              />
            </div>
            <div className="buttons-container">
              <Button
                className="form-cancel-btn"
                label="Cancel"
                disabled={isFormSubmissionInProgress}
                onClick={this.onFormCancel}
                isTransparent
              />
              <Button
                className="form-submit-btn"
                type="submit"
                label={isEditMode ? "Update" : "Add"}
                disabled={!this.canSubmit()}
                isLoading={isFormSubmissionInProgress}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }

  populateFormWithExistingBrochureDetails = () => {
    const { brochureToUpdate, isEditMode } = this.props;
    if (isEditMode && brochureToUpdate) {
      this.setState({
        brochureFileName: brochureToUpdate.label,
        brochureId: brochureToUpdate.id,
      });
    }
  };

  renderFileInput = () => {
    return (
      <FileInput
        onFileChange={this.onFileChange}
        onFileNameUpdate={this.onFileNameUpdate}
        onFileTypeUpdate={this.onFileTypeChange}
        fileNameValue={this.state.brochureFileName}
        allowNameEdit={this.props.isEditMode}
      />
    );
  };

  onFileTypeChange = (type) => {
    this.setState({
      fileType: type,
    });
  };

  onFileChange = (file) => {
    this.setState({
      brochureFile: file,
    });
  };

  onFileNameUpdate = (fileName) => {
    this.setState({
      brochureFileName: fileName,
    });
  };

  canSubmit = () => {
    return (
      (this.props.isEditMode || this.state.brochureFile) &&
      this.state.brochureFileName && this.state.fileType
    );
  };

  onFormSubmit = (e) => {
    e.preventDefault();
    const { isEditMode } = this.props;
    this.setState({
      isFormSubmissionInProgress: true,
    });
    const onSubmitFn = isEditMode
      ? this.submitBrochureEditForm
      : this.submitBrochureCreationForm;
    onSubmitFn();
  };

  submitBrochureCreationForm = () => {
    const newFile = {
      file: this.state.brochureFile,
      fileName: this.state.brochureFileName,
      fileType: this.state.fileType
    };
    const formData = new FormData();
    formData.append("file", newFile.file[0]);
    formData.append("fileName", newFile.fileName);
    formData.append("fileType", newFile.fileType);
    uepClient(
      {},
      {
        "Content-Type": "multipart/form-data",
      }
    )
      .post("/file-info/upload", formData)
      .then((res) => {
        const fileInfo = res.data;
        this.props.onNewBrochureAdded(fileInfo);
        this.props.showAlert({
          variant: "success",
          content: (
            <span>
              <b>Success!</b> The brochure has been added successfully.
            </span>
          ),
        });
      })
      .catch(() => {
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> failed to add the new brochure, please try again!
            </span>
          ),
        });
      })
      .finally(() => {
        this.setState({
          isFormSubmissionInProgress: false,
        });
        this.props.onAddBrochureFormClose();
      });
  };

  submitBrochureEditForm = () => {
    const { brochureFile } = this.state;
    if (brochureFile) {
      this.editBrochure();
    } else {
      this.editBrochureName();
    }
  };

  editBrochure = () => {
    const { brochureFile, brochureFileName, brochureId, fileType } = this.state;
    const editRequest = {
      id: brochureId,
      fileName: brochureFileName,
      updatedFile: brochureFile[0],
      fileType: fileType
    };
    const contentType = "multipart/form-data";

    const formData = new FormData();
    formData.append("id", editRequest.id);
    formData.append("fileName", editRequest.fileName);
    formData.append("updatedFile", editRequest.updatedFile);
    formData.append("fileType", editRequest.fileType);

    uepClient(
      {},
      {
        "Content-Type": contentType,
      }
    )
      .put("/file-info/edit", formData)
      .then((res) => {
        const fileInfo = res.data;
        this.props.onBrochureEdited(fileInfo);
        this.props.showAlert({
          variant: "success",
          content: (
            <span>
              <b>Success!</b> The brochure has been edited successfully.
            </span>
          ),
        });
      })
      .catch(() => {
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> failed to edit the brochure, please try again!
            </span>
          ),
        });
      })
      .finally(() => {
        this.setState({
          isFormSubmissionInProgress: false,
        });
        this.props.onAddBrochureFormClose();
      });
  };

  editBrochureName = () => {
    const { brochureFileName, brochureId, fileType } = this.state;
    const editRequest = {
      id: brochureId,
      fileName: brochureFileName,
      fileType: fileType
    };

    uepClient({})
      .put("/file-info/edit/filename", editRequest)
      .then((res) => {
        const fileInfo = res.data;
        this.props.onBrochureEdited(fileInfo);
        this.props.showAlert({
          variant: "success",
          content: (
            <span>
              <b>Success!</b> The brochure's name has been edited successfully.
            </span>
          ),
        });
      })
      .catch(() => {
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> failed to edit the brochure's name, please try
              again!
            </span>
          ),
        });
      })
      .finally(() => {
        this.setState({
          isFormSubmissionInProgress: false,
        });
        this.props.onAddBrochureFormClose();
      });
  };

  onFormCancel = (e) => {
    e.preventDefault();
    this.props.onAddBrochureFormClose();
  };
}

const AddBrochureFormWithAlert = WithAlert(AddBrochureForm);

export default AddBrochureFormWithAlert;
